import { useMap } from 'react-map-gl'
import { GlobalSearch } from '~/components'
import { useEmbed, useMapCardSizes, useMapEaseTo } from '~/hooks'

export default function MapSearch() {
  const mapRef = useMap()
  const mapCardSizes = useMapCardSizes()
  const mapEaseTo = useMapEaseTo(mapRef as any)
  const { isEmbed } = useEmbed()

  if (isEmbed) {
    return null
  }

  return (
    <GlobalSearch
      className="w-42 overflow-hidden rounded-md shadow-md"
      collapseInput={true}
      onPlaceSelect={({ lat, lng, zoom }) => {
        mapEaseTo({
          zoom: 18,
          center: [lng, lat],
          padding: {
            left: mapCardSizes.list,
            top: 0,
            right: 0,
            bottom: 0,
          },
          duration: 500,
        })
      }}
    />
  )
}
